<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <div style="display:flex">
        <el-form-item
          label="广告主账户id"
          prop="account_id"
        >
          <div style="display:flex">

            <el-button
              type="success"
              size="mini"
              @click="selectID"
            >选择</el-button>
            <el-tag v-if="ruleForm.account_id">{{ ruleForm.account_id }}-{{ account_name }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item
          label="策略名称"
          label-width="80px"
          prop="strategy_name"
          autocomplete="new-password"
        >
          <el-input
            v-model.trim="ruleForm.strategy_name"
            placeholder="请输入"
          />
        </el-form-item>
      </div>
      <div style="display:flex;justify-content: center;align-items: center;">
        <el-form-item
          label="单集价格"
          label-width="150px"
          prop="episode_price"
          autocomplete="new-password"
        >
          <el-input
            v-model.trim="ruleForm.episode_price"
            v-numberOnly
            placeholder="请输入"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
          label="最低充值档位"
          label-width="150px"
          prop="min_recharge_tier"
          autocomplete="new-password"
        >
          <el-input
            v-model.trim="ruleForm.min_recharge_tier"
            v-numberOnly
            style="width: 100px;"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item
          label="起充集数"
          prop="recharge_num"
          style="margin-top: 20px;"
        >
          <el-input
            v-model.trim="ruleForm.recharge_num"
            v-numberOnly
            style="width: 100px;"
            placeholder="请输入"
          />

        </el-form-item>
      </div>

      <el-form-item style="margin-top: 50px;margin-left: 400px;">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="图片库"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择广告主账户id"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleId"
      width="50%"
      append-to-body
    >
      <accoutIdDialog
        ref="id"
        @close="close"
      />
    </el-dialog>
  </div>
</template>
<script>
import chooseimg from '@/views/sourceMaterial/components/imgComp.vue'
// import { alldatalist } from '@/api/providerAccountManagement/servicePorviderList.js'
import accoutIdDialog from './accoutIdDialog.vue'
export default {
  components: {
    chooseimg,
    accoutIdDialog
  },
  directives: {
    numberOnly: {
      bind(el) {
        el.addEventListener('input', function(event) {
          const input = event.target
          let value = input.value

          if (value.length > 4) {
            value = value.slice(0, 4) // 截取前4位数字
          }
          value = value.replace(/[^\d.]/g, '') // 只保留数字和小数点

          const parts = value.split('.')
          if (parts.length > 1) {
            // 如果有小数点，限制小数点后面只能有一位数字
            parts[1] = parts[1].slice(0, 2)
            value = parts.join('.')
          }

          input.value = value
        })
      }
    }
  },
  data() {
    return {
      ruleForm: {
        account_id: '',
        recharge_num: '',
        min_recharge_tier: '',
        episode_price: '',
        strategy_name: ''
      },
      account_name: '',
      dialogVisibleId: false,
      wechatname: '',
      rules: {
        account_id: [{ required: true, message: '请选择', trigger: 'blur' }],
        episode_price: [{ required: true, message: '请输入，支持填写 >= 0.01 的小数，精确到 0.01，单位元', trigger: 'blur' }],
        strategy_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        recharge_num: [{ required: true, message: '请输入，支持填写 >= 0 的整数', trigger: 'blur' }],
        min_recharge_tier: [{ required: true, message: '请输入，支持填写 >= 0.01 的小数，精确到 0.01，单位元', trigger: 'blur' }]
      },
      loading: false,
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      check: undefined,
      wechatVisible: false,
      dialogVisibler: false,
      dialogMerchant: false,
      arrs: [],
      merchant_ids: [],
      typer: null,
      idr: null,
      dialogVisibletwo: false,
      options: [
        {
          value: 'PROFILE_TYPE_DEFINITION',
          label: '自定义类型'
        },
        {
          value: 'PROFILE_TYPE_AUTO_GENERATE ',
          label: '自动填充类型'
        }
      ]
    }
  },
  // 页面初始化挂载dom
  mounted() {
    console.log('111')
    // this.$nextTick(() => {
    //   //  执行echarts方法
    //   this.getLoadEcharts()
    // })
    // this.getLoadEcharts()
  },
  methods: {
    selectID() {
      this.dialogVisibleId = true
      this.$nextTick(() => {
        this.$refs.id.send()
      })
    },
    close(item) {
      this.ruleForm.account_id = item.account_id
      this.account_name = item.account_name
      this.dialogVisibleId = false
    },

    clickicon(img, key, name, item) {
      if (img.endsWith('.mp4') || img.endsWith('.avi') || img.endsWith('.mov') || img.endsWith('.wmv')) {
        return this.$message.info('不是图片，请重新选择')
      } else {
        console.log('img, key:', img, key, name, item)
        this.dialogVisibletwo = false
        this.ruleForm.path = img
        this.ruleForm.md5 = item.md5
      }
    },
    bandarrMerchant(arr, sp_strategy_no, arrname) {
      console.log('66666', arr)
      this.dialogMerchant = false
      this.merchant_ids = arr
      this.ruleForm.merchant_ids = []
      arr.forEach(element => {
        this.ruleForm.merchant_ids.push(element.merchant_id)
        console.log('this.ruleForm.merchant_ids:', this.ruleForm.merchant_ids)
      })
    },
    merchantchat() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    async submitForm(formName) {
      let episode_price = true
      let recharge_num = true
      let min_recharge_tier = true
      console.log(' this.ruleForm.agents_password :', this.ruleForm)
      if (this.ruleForm.episode_price && /^0\d/.test(this.ruleForm.episode_price) && !/\./.test(this.ruleForm.episode_price)) {
        // 以零开头且没有小数点
        // 执行相应的逻辑
        episode_price = false
      }
      if (this.ruleForm.recharge_num && /^0\d/.test(this.ruleForm.recharge_num) && !/\./.test(this.ruleForm.recharge_num)) {
        // 以零开头且没有小数点
        // 执行相应的逻辑
        recharge_num = false
      }
      if (this.ruleForm.min_recharge_tier && /^0\d/.test(this.ruleForm.min_recharge_tier) && !/\./.test(this.ruleForm.min_recharge_tier)) {
        // 以零开头且没有小数点
        // 执行相应的逻辑
        min_recharge_tier = false
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (episode_price && recharge_num && min_recharge_tier) {
            this.$emit('submit', this.ruleForm, () => {
              this.ruleForm = {
                account_id: '',
                recharge_num: '',
                min_recharge_tier: '',
                episode_price: '',
                strategy_name: ''
              }
            })
          } else {
            this.$message.info('请输入正确的格式')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    wechatclick() {
      this.wechatVisible = true
      this.$nextTick(() => {
        this.$refs.wechatview.send()
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async changewr(val, item) {
      console.log(val, item)
      // await setReceiveMiniprogram({
      //   receive_miniprogram: val,
      //   id: item.id
      // })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async send(row) {
      console.log('---', row)
      // const item = JSON.parse(JSON.stringify(row))
      // this.ruleForm.account_id = item.account_id
      // this.getlist(id, type)
    },
    rightclick(index) {
      this.arrs.splice(index, 1)
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.pic_img {
  width: 95px;
}
</style>
